import { SwapVert } from '@mui/icons-material';
import { Box, Button, Card, Typography } from '@mui/material';
import _ from 'lodash';
import { useMemo, useState } from 'react';
import * as setup from 'setup';
import { useResizeObserver } from 'use-resize-observer';
import HistogramChart from '../HistogramChart/HistogramChart';
import TimelineChart from '../TimelineChart/TimelineChart';
import { ChartTooltip } from './Chart.styles';

export default function Chart({ decimals, histogram, initial, multiplier, timeline, variant, onToggle }: ChartProps) {

    const [type, setType] = useState(initial);
    const containerObserver = useResizeObserver<HTMLDivElement>();

    function handleToggle() {
        const newType = type === 'timeline' ? 'histogram' : 'timeline';
        if (onToggle) {
            onToggle?.(newType);
        } else {
            setType(newType);
        }
    }

    const variantSetup = useMemo(() => {
        return setup.charts.variants[variant];
    }, [
        variant,
    ]);

    return (
        <Card>
            <Box sx={{
                boxShadow: '0px 2px 40px 0px rgba(0, 0, 0, 0.102)'
            }}>
                <Box
                    sx={{
                        alignItems: 'center',
                        borderBottom: '2px solid rgba(0,0,0,0.05)',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 2,
                        padding: 1
                    }}>
                    {((!!timeline && !!histogram) || !!onToggle) && (
                        <Button startIcon={<SwapVert />} size="small" variant="text" onClick={handleToggle}>
                            {_.capitalize(type)}
                        </Button>
                    )}
                    <Typography align="center" variant="montserrat616">
                        {variantSetup.title}
                    </Typography>
                </Box>
                <Box ref={containerObserver.ref} sx={{
                    marginTop: 3
                }}>
                    {!!histogram && (type === 'histogram' || !timeline) && (
                        <HistogramChart
                            {...histogram}
                            axes={{
                                x: variantSetup.axes.y,
                                y: variantSetup.axes.x,
                            }}
                            decimals={decimals || 0}
                            multiplier={multiplier || 1}
                            width={containerObserver.width || 0}
                        />
                    )}
                    {!!timeline && (type === 'timeline' || !histogram) && (
                        <TimelineChart
                            {...timeline}
                            axes={variantSetup.axes}
                            decimals={decimals || 0}
                            multiplier={multiplier || 1}
                            width={containerObserver.width || 0}
                        />
                    )}
                </Box>
            </Box>
            <ChartTooltip id="chart-tooltip" place="right" globalCloseEvents={{ clickOutsideAnchor: true }} />
        </Card>
    );
}